// src/hooks/useScrollingText.ts

import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

type ScrollDirection = "left" | "right";

interface ScrollingTextOptions {
  selector: string;
  direction?: ScrollDirection;
  scrollEffect?: boolean;
  infinite?: boolean;
}

export const useScrollingText = (config: ScrollingTextOptions[]) => {
  useEffect(() => {
    const animations: (gsap.core.Tween | gsap.core.Timeline)[] = [];


    config.forEach(({ selector, direction = "left", scrollEffect = true, infinite = true }) => {
      const elements = document.querySelectorAll(selector);
      if (!elements.length) return;

      elements.forEach((el) => {
        const timeline = gsap.timeline();
        const moveDistance = 1000;

        const infiniteTween = timeline.to(el, {
          x: direction === "left" ? -moveDistance : moveDistance,
          duration: 50,
          repeat: infinite ? -1 : 0,
          ease: "linear",
        });

        animations.push(infiniteTween);

        if (scrollEffect) {
          const scrollTween = gsap.to(el, {
            xPercent: direction === "left" ? -5 : 5,
            scrollTrigger: {
              trigger: el,
              scrub: 1,
            },
          });
          animations.push(scrollTween);
        }
      });
    });

    return () => {
      animations.forEach(anim => anim.kill());
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [config]);
};
